export const Spacer = (props: { s: number }) => {
  return <div style={{ padding: `${4 * (props.s / 2)}px` }}></div>;
};
